export enum HistoryStatus {
  waiting = 1,
  approved = 2,
  rejected = 3,
}
